import { FormFieldError } from '@forms/FormFieldError/FormFieldError';
import { ErrorMessage, Input, Select } from '@iwoca/orion';
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { months } from '../../../../../../helpers/months';
import { TFormValues } from '../MSHForm.types';
import styles from '../MSHModal.module.css';

const DOBFields = ({
    errors,
    register,
    disabled,
    variant
}: {
    errors: FieldErrorsImpl<TFormValues>;
    register: UseFormRegister<TFormValues>;
    disabled: boolean;
    variant: 'legacy' | 'new';
}) => {
    const intl = useIntl();

    return (
        <div className={variant === 'new' ? 'w-full' : styles.fields}>
            {variant !== 'new' &&
                (errors.day || errors.month || errors.year) && (
                    <FormFieldError
                        message={intl.formatMessage({
                            id: '_.modal.major_shareholder_check_form.error.valid_DOB_required',
                            defaultMessage: 'Please enter a valid date of birth'
                        })}
                    />
                )}

            <label
                className={
                    variant === 'new' ? 'mb-m block text-m' : styles.label
                }
            >
                Date of birth
            </label>

            <div
                className={variant === 'new' ? 'flex w-full gap-s' : undefined}
            >
                {/* eslint-disable-next-line iwoca/input-a11y */}
                <Input
                    {...register('day', {
                        required: true,
                        minLength: {
                            value: 2,
                            message: 'Please enter a valid number between 01-31'
                        },
                        maxLength: {
                            value: 2,
                            message: 'Please enter a valid number between 01-31'
                        }
                    })}
                    minLength={2}
                    maxLength={2}
                    wrapperClassName={
                        variant === 'new'
                            ? 'flex-1'
                            : `${styles.day} ${styles.field}`
                    }
                    id={'day'}
                    placeholder={intl.formatMessage({
                        id: '_.modal.major_shareholder_check_form.day_field_placeholder',
                        defaultMessage: 'Day (e.g. 05)'
                    })}
                    disabled={disabled}
                />
                <Select
                    {...register('month', {
                        required: true
                    })}
                    wrapperClassName={
                        variant === 'new'
                            ? 'flex-1'
                            : `${styles.month} ${styles.field}`
                    }
                    id="month"
                    placeholder={intl.formatMessage({
                        id: '_.modal.major_shareholder_check_form.month_field_placeholder',
                        defaultMessage: 'Month'
                    })}
                    data-testid="month"
                    disabled={disabled}
                >
                    {months.map(({ value, label }, index) => (
                        <option key={index + value} value={value}>
                            {label}
                        </option>
                    ))}
                </Select>
                {/* eslint-disable-next-line iwoca/input-a11y */}
                <Input
                    {...register('year', {
                        required: true,
                        minLength: {
                            value: 4,
                            message: 'Please enter a valid year'
                        },
                        maxLength: {
                            value: 4,
                            message: 'Please enter a valid year'
                        }
                    })}
                    minLength={4}
                    maxLength={4}
                    wrapperClassName={
                        variant === 'new'
                            ? 'flex-1'
                            : `${styles.year} ${styles.field}`
                    }
                    id={'year'}
                    placeholder={intl.formatMessage({
                        id: '_.modal.major_shareholder_check_form.year_field_placeholder',
                        defaultMessage: 'Year (e.g. 1995)'
                    })}
                    disabled={disabled}
                />
            </div>
            {variant === 'new' &&
                (errors.day || errors.month || errors.year) && (
                    <ErrorMessage className="mt-m">
                        <FormattedMessage
                            id="_.modal.major_shareholder_check_form.error.valid_DOB_required"
                            defaultMessage="Please enter a valid date of birth"
                        />
                    </ErrorMessage>
                )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DOBFields;
